import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DynamicViewEngineModule } from "@cotecna/dynamic-view-engine";
import { FabSpeedDialModule } from "@cotecna/material";
import { ToolbarModule } from "@cotecna/shell";
import { TablesModule } from "@cotecna/tables";
import { TabsModule } from "@cotecna/tabs";
import { ItInspectorsModule } from "src/app/inspectors/inspectors.module";

import { ItemsModule } from "../../items/items.module";
import { ScopeOfWorkModule } from "../../scope-of-work/scope-of-work.module";
import { AuthInterceptor } from "../interceptors/auth.interceptor";
import { WebInterceptor } from "../interceptors/web.interceptor";
import { InspectionDocumentsComponent } from "./documents/inspection-documents.component";
import { AdditionalFieldsEditableModeComponent } from "./info/additional-fields-editable-mode/additional-fields-editable-mode.component";
import { GeneralInfoEditableModeComponent } from "./info/general-info-editable-mode/general-info-editable-mode.component";
import { InspectionDetailsInfoComponent } from "./info/inspection-details-info.component";
import { InspectionDetailsRoutingModule } from "./inspection-details-routing.module";
import { InspectionDetailsItemsComponent } from "./items/inspection-details-items.component";
import { InspectionDetailsPhotosComponent } from "./photos/inspection-details-photos.component";
import { InspectionDetailsSowComponent } from "./sow/inspection-details-sow.component";
import { InspectionDetailsTabsComponent } from "./tabs/inspection-details-tabs.component";
import { InspectionDetailsTimelogComponent } from "./timelog/inspection-details-timelog/inspection-details-timelog.component";
import { InspectionTimesheetComponent } from "./timelog/inspection-timelog-timesheet/inspection-timelog-timesheet.component";
import { TimelogContainerComponent } from "./timelog/timelog-container/timelog-container.component";

@NgModule({
  declarations: [
    InspectionDetailsTabsComponent,
    InspectionDetailsInfoComponent,
    InspectionDetailsItemsComponent,
    InspectionDetailsSowComponent,
    InspectionDetailsPhotosComponent,
    InspectionDocumentsComponent,
    InspectionDetailsTimelogComponent,
    TimelogContainerComponent,
    GeneralInfoEditableModeComponent,
    AdditionalFieldsEditableModeComponent,
  ],
  imports: [
    DynamicViewEngineModule,
    CommonModule,
    InspectionDetailsRoutingModule,
    ItInspectorsModule,
    TabsModule,
    ToolbarModule,
    MatCardModule,
    MatChipsModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    TablesModule,
    FabSpeedDialModule,
    ItemsModule,
    ScopeOfWorkModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    InspectionTimesheetComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WebInterceptor,
      multi: true,
    },
  ],
})
export class InspectionDetailsModule {}
